export default __webpack_public_path__ + "static/media/delete-user.e75efe69.svg";